import { z } from 'zod';

import { JobHistoryLevel, JobHistoryType as JobHistoryNativeType } from '@/common/graphql';

export const EmployeeJobHistory = z.object({
  id: z.string().default(''),
  effectiveDateStart: z.string().default(''),
  effectiveDateEnd: z.string().nullable().default(''),
  type: z.nativeEnum(JobHistoryNativeType).nullable().default(null),
  level: z.nativeEnum(JobHistoryLevel).nullable().default(null),
  countryId: z.string().default(''),
  locationId: z.string().default(''),
  location: z.string().default(''),
  businessUnitId: z.string().default(''),
  businessUnit: z.string().default(''),
  businessUnitDefinition: z.string().nullable().default(''),
  divisionId: z.string().default(''),
  division: z.string().default(''),
  departmentId: z.string().default(''),
  department: z.string().default(''),
  departmentDefinition: z.string().nullable().default(''),
  jobId: z.string().default(''),
  job: z.string().default(''),
  jobDefinition: z.string().nullable().default(''),
  jobTitle: z.string().nullable().default(''),
  team: z.string().nullable().default(''),
  regionalRole: z.boolean().default(false),
  departmentLead: z.boolean().default(false),
  primaryManagerId: z.string().nullable().default(null),
  dottedLineManagerId: z.string().nullable().default(null),
});
export type EmployeeJobHistoryType = z.infer<typeof EmployeeJobHistory>;
